import { useAppWsEvent } from "@hooks/useAppWS";
import { useBalanceRefetchOnReconnect } from "@hooks/useBalanceRefetchOnReconnect";
import useDepositFailedNotification from "@hooks/useDepositFailedNotification";
import useDepositNotification from "@hooks/useDepositNotification";
import { useDepositStatusWatcher } from "@hooks/useDepositStatusWatcher";
import { useTokenWatcher } from "@hooks/useTokenWatcher";
import useWithdrawalCancelledNotification from "@hooks/useWithdrawalCancelledNotification";
import { Outlet } from "react-router-dom";

/**
 * Websocket route layout
 * Which is used to connect to websocket
 */
const WSRouteLayout = () => {
  useTokenWatcher();
  useAppWsEvent();
  useDepositNotification();
  useDepositFailedNotification();
  useDepositStatusWatcher();
  useBalanceRefetchOnReconnect();
  useWithdrawalCancelledNotification();

  return <Outlet />;
};

export default WSRouteLayout;
